import { render, staticRenderFns } from "./RecommendFriend.vue?vue&type=template&id=591e7e36&"
import script from "./RecommendFriend.vue?vue&type=script&lang=js&"
export * from "./RecommendFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports